import { useEffect, useState } from "react";

import EasyTimer from "easytimer.js";

import { Stack } from "@components/Stack";
import { Typography } from "@components/Typography";

import { useLayoutBreakpoint } from "@hooks/useLayoutBreakpoint";

import { useBroadcastStatusDataQuery } from "@storage/queries/broadcast/useBroadcastStatusDataQuery";

import { timeTestDiff } from "@utils/timeTestDiff";

const timer = new EasyTimer();

export const BroadcastTimer = () => {
	const [time, setTime] = useState<string | null>(null);
	const hh = "00",
		mm = "00",
		ss = "00";

	const broadcastStatusDataQuery = useBroadcastStatusDataQuery();
	const { DESKTOP, MAX_DESKTOP } = useLayoutBreakpoint();
	const isDesktop = DESKTOP || MAX_DESKTOP;

	useEffect(() => {
		if (broadcastStatusDataQuery.startedAt > 0) {
			const time = timeTestDiff(broadcastStatusDataQuery.startedAt, broadcastStatusDataQuery);
			timer.reset();
			timer.stop();
			timer.removeAllEventListeners();
			timer.start({
				precision: "seconds",
				startValues: {
					seconds: Math.round(time.seconds),
					minutes: time.minutes,
					hours: time.hours,
				},
			});

			timer.addEventListener("secondsUpdated", () => {
				setTime(timer.getTimeValues().toString());
			});
		} else {
			timer.reset();
			timer.stop();
			timer.removeAllEventListeners();
			setTime(null);
		}
	}, [broadcastStatusDataQuery.startedAt, broadcastStatusDataQuery.broadcastDurationSec]);

	return (
		<Stack direction="row" className={!isDesktop ? "mr-3" : ""}>
			{time ? (
				<Typography type="span" className="w-19.5" size="lg" color="text" padding="none">
					{time}
				</Typography>
			) : (
				<>
					<Typography type="span" size="lg" color="grey-tertiary" padding="none">
						{hh}:
					</Typography>
					<Typography type="span" size="lg" color="grey-tertiary" padding="none">
						{mm}:
					</Typography>
					<Typography type="span" size="lg" color="grey-tertiary" padding="none">
						{ss}
					</Typography>
				</>
			)}
		</Stack>
	);
};
